import {Injectable} from '@angular/core';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Deserialize} from 'cerialize';
import {ProjetTravaux} from '../models/projetTravaux';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, filter, map, switchMap} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ParcourTravauxService {

  baseApiUrl = environment.api.baseUrl;
  private _projetsTravaux: BehaviorSubject<ProjetTravaux[]> = new BehaviorSubject(null);
  public readonly projetsTravaux: Observable<ProjetTravaux[]> = this._projetsTravaux.asObservable().pipe(filter(projetsTravaux => projetsTravaux != null));
  private hiddenFields = [];

  constructor(
    private http: HttpClient,
  ) {
  }

  public processProjetTravaux(projetTravaux: any, id = ''): Promise<any> {
    const route = `${this.baseApiUrl}projet-travaux/process/${id}`;

    return this.callEndPoint(route, projetTravaux);
  }

  public calculateDpeProjetTravauxWithData(projetTravaux: any): Promise<any> {
    const route = `${this.baseApiUrl}projet-travaux/calculate-dpe`;

    return this.callEndPoint(route, projetTravaux);
  }

  public addMyProjetTravaux(): Promise<any> {
    return this.http.get(`${this.baseApiUrl}projet-travaux/save/redirect`).toPromise().then((data) => {
      return data;
    });
  }

  private callEndPoint(route, projetTravaux) {
    return this.http.post(route, projetTravaux).toPromise().then(
      (data) => {
        return Deserialize(data, ProjetTravaux);
      },
      (data) => {
        if (data.status === 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  clearFieldsAndCheckValid(conditions: { field: string; condition: () => boolean }[], form: UntypedFormGroup): boolean {
    const ignoreItems = [];
    conditions.forEach(condition => {
      const fieldForm = form.get(condition.field);
      if (fieldForm) {
        if (condition.condition()) {
          ignoreItems.push(condition.field);
          if (fieldForm.value !== null) {
            fieldForm.patchValue(null);
          }
        }
      }
    });
    for (const field in form.controls) {
      if (!ignoreItems.includes(field) && !form.get(field).valid) {
        return false;
      }
    }

    return true;
  }

  loadProjetsTravaux(): Observable<ProjetTravaux[]> {
    return this.http.get(`${this.baseApiUrl}projet-travaux`).pipe(
      map(data => Deserialize(data, ProjetTravaux)),
      switchMap((projets: ProjetTravaux[]) => {
        this._projetsTravaux.next(projets);
        return this.projetsTravaux;
      }),
      catchError((error) => {
        console.error('An unexpected error occurred:', error);
        return of([]);
      })
    );
  }

  public findById(id: number): Promise<ProjetTravaux> {
    return this.http.get(`${this.baseApiUrl}projet-travaux/${id}`).toPromise().then(
      data => {
        return Deserialize(data, ProjetTravaux);
      }
    );
  }

  changeFormatProjectData(data: any): any {
    return data;
  }

  public getDemoBlogData() {
    const demoBlogFormData = this.getDemoBlogStorage();
    demoBlogFormData.typeGazLame = demoBlogFormData.typeGazLame ?? 'inconnu';
    demoBlogFormData.nbGenerateurEcs = demoBlogFormData.nbGenerateurEcs ?? 1;
    demoBlogFormData.nbGenerateurChauffage = demoBlogFormData.nbGenerateurChauffage ?? 1;
    return demoBlogFormData;
  }

  private getDemoBlogStorage() {
    const demoBlogFormData = localStorage.getItem('demo-blog');
    return demoBlogFormData ? JSON.parse(demoBlogFormData) : {};
  }
}
